/**
 * @Description POI 及 配套
 */
import { FC, useEffect, useState } from 'react';
import styles from './index.module.less';
import V2PieChart from '@/common/components/Charts/V2PieChart';
import { Table } from 'antd';
import { v4 } from 'uuid';
import { spotEvaluationSurround, spotEvaluationSurroundShare } from '@/common/api/spotevaluation';
import { SpotTypeEnum } from '../../../../ts-config';

const POIMating: FC<any> = ({ detail, drawerData, tenantId }) => {
  const [columnsAndData, setColumnsAndData] = useState<any>(null); // 地图实例

  useEffect(() => {
    if (detail?.lng) {
      loadData();
    }
  }, [detail]);

  const loadData = async () => {
    const { lng, lat, type: typeVal, modelClusterId, modelConfigId, radius } = drawerData || {};
    const params: any = {
      type: typeVal,
      modelConfigId,
    };
    if (typeVal === SpotTypeEnum.Mall) {
      params.modelClusterId = modelClusterId;
    }
    if (typeVal === SpotTypeEnum.Street) {
      params.lng = detail?.lng || lng;
      params.lat = detail?.lat || lat;
      params.radius = radius;
    }
    if (tenantId) {
      params.tenantId = tenantId;
    }
    const api = tenantId ? spotEvaluationSurroundShare : spotEvaluationSurround;
    const surroundingInfoVO = await api(params
    //   {
    //   lng: detail.lng,
    //   lat: detail.lat,
    //   tenantId,
    //   type: drawerData.type,
    //   modelClusterId: drawerData.modelClusterId,
    //   modelConfigId: drawerData.modelConfigId
    // }
    );
    const column:any = [{ key: 'distance', dataIndex: 'distance', title: 'POI数量', width: 110 }];
    const data:any = [];
    surroundingInfoVO?.distributionVOs?.map((item, index) => {
      data[index] = {
        distance: item?.name
      };
      item?.children.map((item) => {
        const value = column.find((cur) => cur?.title === item?.name);
        const uuid = v4();
        if (!value) {
          column.push({ key: uuid, dataIndex: uuid, title: item?.name, width: 54 });
        }
        data[index] = {
          ...data[index] || null,
          [value?.key || uuid]: item?.num
        };
      });
    });
    setColumnsAndData({
      introduction: surroundingInfoVO?.introduction,
      column,
      data,
      rateVOs: surroundingInfoVO?.rateVOs?.map((item) => ({
        ...item,
        value: item.rate
      }))
    });
  };

  return (
    <>
      {columnsAndData ? <>
        <div className={styles.desc}> {columnsAndData?.introduction || '-'} </div>
        <div className={styles.surroundingFacility}>
          <div className={styles.table} >
            <div className='fs-14 c-222 bold mb-10'>POI数量</div>
            {columnsAndData?.data?.length ? <Table
              rowKey='name'
              rowClassName={(record, i) => (i % 2 === 1 ? 'zebraLine' : '')}
              scroll={{ x: 440 }}
              dataSource={columnsAndData?.data}
              columns={columnsAndData?.column}
              pagination={false}
            /> : <></>}
          </div>
          <div className={styles.pieChart}>
            <div className='fs-14 c-222 bold mb-10'>配套</div>
            <V2PieChart
              type='circle'
              seriesData={[{
                data: columnsAndData?.rateVOs || [],
                unit: '%',
                animation: false,
                radius: ['46%', '58%'],
                center: ['28%', '52%']
              }]}
            />
          </div>
        </div>
      </>
        : <></>}
    </>
  );
};

export default POIMating;
